export default {
  bind(el, bindings, vnode) {
    
    let button = el.querySelector('.js-scroll-down')
    let block = document.querySelector('.js-scroll-block')
    let menuItem = el.querySelectorAll('.js-item')
    let sections = el.querySelectorAll('.js-sections')
    let menuItemMobile = el.querySelectorAll('.js-item-mobile')
    let zero = 0
    let offset = 50
    if (button) {
      let coordinate = block.offsetTop - offset
      button.onclick = () => {
        window.scrollTo(zero, coordinate)
      }
    }
    function removeLocationHash(){
      var noHashURL = window.location.href.replace(/#.*$/, '')
      window.history.replaceState('', document.title, noHashURL) 
    }
    
    window.addEventListener("popstate", function(event){
      removeLocationHash()
    })

    window.addEventListener("hashchange", function(event){
      event.preventDefault()
      removeLocationHash()
    })

    window.addEventListener("load", function(){
      removeLocationHash()
    })
    // if (sections) {

    //   if (window.matchMedia("(min-width: 992px)").matches) {
  
    //     menuItem.forEach((el, i) => {
    //       el.onclick = () => {
    //         if (el.dataset.section == sections[i].dataset.section) {
    //           let coordinate = sections[i].offsetTop - offset
    //           window.scrollTo(zero, coordinate)
    
    //         }
    //         if(document.location.href.indexOf('index.html') === -1){
    //           location="http://brandboosting.loc/index.html"
    //         }
    //       }
    //     })
    //   } else {
    //     menuItemMobile.forEach((el, i) => {
    //       el.onclick = () => {
    //         if (el.dataset.section == sections[i].dataset.section) {
    //           let coordinate = sections[i].offsetTop - offset
    //           window.scrollTo(zero, coordinate)
    
    //         }
    //       }
      
    //     })
    //   }
    // }
  }
}



// WEBPACK FOOTER //
// ./src/js/directives/scroll-down/scroll-down.js